<template>
    <HeroSection
        :title="title"
        :title-highlight="titleHighlight"
        :subtitle="subtitle"
        :primary-action="primaryAction"
        :secondary-action="secondaryAction"
        :highlights="highlights"
        :overlay="true"
        :background-image="backgroundImage"
        :animate-title-words="true"
        :lang="'de'"
    >
        <template #title>
            <span class="TitleHighlight">{{ titleHighlight }}</span>
            Ihr zuverlässiger Partner für moderne<br />
            Taxi- und Mietwagenverwaltung
        </template>
    </HeroSection>
</template>
<script>
import HeroSection from '@/components/HeroSection';
import { trackCTA } from '@/services/analytics';

export default {
    components: {
        HeroSection,
    },
    data() {
        return {
            titleHighlight: 'TSE-konform mit uns',
            title: '',
            subtitle:
                'Erfüllen Sie alle TSE-Anforderungen automatisch mit unserer zertifizierten Softwarelösung. TSE-Konformität wird ab Januar 2026 Pflicht – bereiten Sie sich jetzt vor.',
            primaryAction: {
                to: '/register',
                text: 'Kostenlos registrieren',
                icon: 'ri-arrow-right-line',
                onClick: () => {
                    trackCTA.click('register', 'hero_section', 'primary');
                },
            },
            secondaryAction: {
                href: '#tse-compliance',
                text: 'TSE-Details',
                icon: 'ri-arrow-down-double-line',
                onClick: () => {
                    trackCTA.click('learn_more', 'hero_section', 'secondary');
                },
            },
            highlights: [
                {
                    icon: 'ri-shield-check-line',
                    text: 'TSE-konform',
                },
                {
                    icon: 'ri-money-dollar-circle-line',
                    text: 'Kosten reduzieren',
                },
                {
                    icon: 'ri-line-chart-line',
                    text: 'Zukunftssicher',
                },
            ],
            backgroundImage: '/banner-optimized.webp',
        };
    },
};
</script>

<style lang="scss" scoped>
@supports not (background-image: url('data:image/webp;base64,')) {
    :deep(.HeroSection) {
        background-image: url('/banner-optimized.jpg') !important;
    }
}
</style>
